<div
    class="image-placeholder"
    [class.image__placeholder__align_center]="imageItem?.textAlign === 'center'"
    [class.image__placeholder__readonly]="readOnly || (imageItem?.src && !imageItem?.isSelectable && !imageItem?.disableInteractions)">
    <div
        [class]="noStyle ? '' : 'image-placeholder__image'"
        [ngClass]="getImageClass(imageItem!)"
        (click)="handleImageClick()"
        [style.height.px]="imageItem?.height ?? 120">
        <i
            *ngIf="!imageItem?.src"
            [style.width.px]="imageItem?.height ?? 120"
            [ngClass]="placeholder">
        </i>
        <img
            *ngIf="imageItem?.src"
            [height]="imageItem?.height ?? 120"
            [attr.width]="imageItem?.width ?? null"
            [alt]="imageItem?.alt"
            [src]="imageItem?.src"
            [ds-tooltip]="imageItem?.tooltip!"
            [dsTooltipConfig]="{ showTriggerDelay: 500 }"
            [ngStyle]="
                imageItem?.verticalPadding || imageItem?.horizontalPadding
                    ? {
                          objectFit: 'contain',
                          padding: (imageItem?.verticalPadding ?? 0) + 'px ' + (imageItem?.horizontalPadding ?? 0) + 'px'
                      }
                    : null
            " />
    </div>
    <label
        *ngIf="showLabel && imageItem?.label"
        class="image__placeholder__label"
        [ngClass]="{ 'image__placeholder__label--align-center': imageItem?.textAlign === 'center' }">
        {{ imageItem?.label }}
    </label>
</div>
